import RulesOfConduct from '../component/page/RulesOfConduct';
import GameFlow from "../component/page/GameFlow";
import Tool from "../component/page/Tool";

const namedMap = {
    'gameFlow': <GameFlow/>,
    'rulesOfConduct': <RulesOfConduct/>,
    'tool': <Tool/>,
};

export default namedMap;
